<template>
    <v-dialog v-model="dialog" width="380" persistent>
        <v-card>
            <v-card-text class="text-center pt-10">
                <v-progress-circular
                    indeterminate
                    size="50"
                ></v-progress-circular>

                <br />

                <h3 class="mt-7 mb-4">
                    {{ $t("authentication.logging-out") }}...
                </h3>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: "LoggingOut",
    data() {
        return {
            dialog: false,
        };
    },
    methods: {
        open() {
            this.dialog = true;
        },
        close() {
            this.dialog = false;
        },
    },
};
</script>